import { LegacyWidget, LegacyWidgetProperties } from '../types';

export const getWidgetProperties = <WD = LegacyWidgetProperties>(
    legacyWidget?: LegacyWidget<WD>,
    excludedQueryKeyWidgetProperties: Array<keyof WD> = [],
) => {
    if (!legacyWidget?.properties || !excludedQueryKeyWidgetProperties?.length) {
        return legacyWidget;
    }

    const properties = { ...legacyWidget, properties: { ...legacyWidget.properties } };
    for (const excludedProperty of excludedQueryKeyWidgetProperties) {
        delete properties.properties[excludedProperty];
    }
    return properties;
};
